export default function PHP_addAttribute() {
  return (
    <div>
      <h1>PHP_addAttribute</h1>
    </div>
  );
}
